import { Tag, Col, Panel, Table, Whisper, IconButton, Popover, Dropdown } from "rsuite"
import MoreIcon from '@rsuite/icons/legacy/More';

const { Cell } = Table;

export default function PlatformCell ({ rowData, dataKey, ...props }) {
    return (
        <Cell {...props}>
            <div className="ts-table-cell-content">
            { rowData[dataKey] &&
                <Tag color={rowData.validated ? "green" : "red"}>{rowData[dataKey] ? "Платформа №" + rowData[dataKey] : null}</Tag>
            }
            </div>
        </Cell>
    );
};